import React, { useEffect, useState } from 'react'
/**
 * [useTimer Custom hook for description]
 * @param  function callback [description]
 * @param  int  minutes start
 * @param  int  seconds start
 * @return string  With format time
 */

const useTimer = (setIsEnabled = () => { }, minutesStart, secondsStart) => {

    const [minutes, setMinutes] = useState(minutesStart)
    const [seconds, setSeconds] = useState(secondsStart)
    const [refresh, setRefresh] = useState(1)
    var myInterval = () => { }

    useEffect(() => {
        count()
        return () => {
            clearInterval(myInterval)
        }
    }, [refresh])

    const count = () => {
        var minutes = minutesStart
        var seconds = secondsStart
        myInterval = setInterval(() => {
            if (seconds > 0) {
                seconds = seconds - 1
                setSeconds(seconds)
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    setIsEnabled(true)
                    clearInterval(myInterval)
                } else {
                    minutes = minutes - 1
                    setMinutes(minutes)
                    seconds = 59
                    setSeconds(seconds)
                }
            }
        }, 1000)
    }
    
    return [`${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`, () => setRefresh(new Date().getSeconds())]
}

export default useTimer